import { SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { trackByProp } from '@recruitee/common';

import { AvatarComponent } from '../avatar/avatar.component';
import { GroupComponent } from '../group/group.component';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';

export interface CandidatesAvatars {
  name: string;
  emails: string[];
  id: number;
  photoThumbUrl: string;
  initials: string;
  hasAvatar: boolean;
  isAnonymous?: boolean;
}

@Component({
  selector: 'rt-candidates-avatars',
  templateUrl: './candidates-avatars.component.html',
  styleUrls: ['./candidates-avatars.component.less'],
  standalone: true,
  imports: [AvatarComponent, GroupComponent, IconColorDirective, IconComponent, SlicePipe],
})
export class CandidatesAvatarsComponent {
  @Input() public candidates?: CandidatesAvatars[] = [];

  public trackByCandidate = trackByProp<CandidatesAvatars>({ prop: 'id' });
}
